/**
 * Configuration and Message content for use by CloudSent POS Admin
 */

export default {
    fuse: {
        admin: {
            version: 'v5.19.2',
        },
        api: {
            LOCAL_URI: 'http://localhost:8081',
            LOCAL_AUTH_URI: 'https://admin.svc.cloudsent.com',
            LOCAL_AUTH_URI_DEV: 'https://admin.fuse.dev.d4l.cloud',
            KEYCLOAK_AUTH_URI: 'https://iam.svc.cloudsent.com',
            RELATIVE_API_URI: '',
            AUTH_ENDPOINT: '/api/v5/auth/user',
            EXCHANGE_ENDPOINT: '/api/v5/ktx/exchange',
            KEYCLOAK_ACCOUNT_ENDPOINT: '/account#/personal-info',
            KEYCLOAK_AUTH_ENDPOINT: '/protocol/openid-connect/auth',
            KEYCLOAK_LOGOUT_ENDPOINT: '/protocol/openid-connect/logout',
            KEYCLOAK_TOKEN_ENDPOINT: '/protocol/openid-connect/token',
            REALM_PATH: '/realms/corp'
        },
        action: {
            delete: 'Delete',
            show: 'Show',
            list: 'List',
            save: 'Save',
            create: 'Create',
            edit: 'Edit',
            cancel: 'Cancel',
            refresh: 'Refresh',
            add_filter: 'Add filter',
            remove_filter: 'Remove this filter',
            back: 'Go Back',
        },
        boolean: {
            true: 'Yes',
            false: 'No',
        },
        client: {
            location: '0000',
            register: '0',
            user: '1111',
            device: 'admin'
        },
        copyright: {
            owner: 'CloudSent POS',
            legalText: 'All rights reserved.',
        },
        product_unit: {
            price_min: 'Price must be above zero.'
        },
        discount: {
            type: 'global',
        },
        inventory: {
            adjustment_type: 'admin_adjustment',
        },
        notification: {
            updated: 'Element updated.',
            created: 'Element created.',
            deleted: 'Element deleted.',
            item_doesnt_exist: 'Element does not exist.',
            no_data: 'No data available.',
            http_error: 'Server communication error.',
            server_error: 'Server error.',
        },
        page: {
            list: '%{name} List',
            edit: '%{name} #%{id}',
            show: '%{name} #%{id}',
            create: 'Create %{name}',
            delete: 'Delete %{name} #%{id}',
            dashboard: 'Dashboard',
            not_found: 'Not Found',
        },
        sections: [
            'admin',
            'loyalty_csr',
            'loyalty_all',
            'loyalty_vo',
            'locations',
            'locations_vo',
            'products_all',
            'products_np',
            'products_vo',
            'inventory',
            'inventory_vo',
            'pos_kit',
            'pos_kit_vo',
            'pos_users',
            'pos_users_vo',
            'configuration',
            'configuration_vo'
        ]
    },
};



// WEBPACK FOOTER //
// ./src/Fuse/messages.js